import { useEffect } from 'react';
import SelectOffer from '../select/SelectOffer';

const StepOffer = ({
  apiUrl,
  dataCollection,
  updateDataCollection,
  activeStep,
  setActiveStep,
  step,
  updateValidation,
}) => {
  function handleSelect(offer) {
    const insertData = {
      offer: offer,
      recipient: offer.recipient,
      recipientType: offer.recipientType,
      title: offer.title,
    };
    updateDataCollection(insertData);

    //next step
    setActiveStep(activeStep + 1);
  }

  useEffect(() => {
    if (dataCollection && dataCollection.offer) updateValidation(true);
  }, []);

  return (
    <SelectOffer
      apiUrl={apiUrl}
      onSelect={handleSelect}
      filter={apiUrl ? '' : 'status[eq]=0'}
      selected={dataCollection && dataCollection.offer}
    />
  );
};

export default StepOffer;
